export enum ProgramDateTypes {
  'Nomination-Window' = 1,
  'Scrubbing-Window' = 2,
  'Judging-Window' = 3,
  'Review-&-Designate-Window' = 4,
  'Compliance-&-Revisions-Window' = 5,
  'Winners-Window' = 6
}  